import _ from 'lodash'
import Component from 'vue-class-component'
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons'

import { Container, Item } from '@skinsoft/types'
import { ItemDataStore, WorkspaceDataStore } from '@skinsoft/entity'
import { getCurrentDateAsSkinDate } from '@skinsoft/utils'

import { ReactiveVue } from '@skinsoft/reactive-vue'
import { LocationSelectorPopup } from '@skinsoft/entity-ui/src/location/location-selector-popup'
import { ChooseItemModal } from '../../../../entity/component/choose-item-modal'
import { SelectItemMultipleModal } from '../../../../entity/component/select-item-multiple-modal'
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics'

@Component({
    components: {
        sSelectItemMultipleModal: SelectItemMultipleModal,
        sLocationSelectorPopup: LocationSelectorPopup,
        sChooseItemModal: ChooseItemModal,
    },
    template: require('./map-icon-toggle.html'),
})
export class MapIconToggle extends ReactiveVue {
    public mapIcon = faLocationArrow
    public selectedItem: Item | null = null

    public $itemDatastore: ItemDataStore
    public $workspaceDataStore: WorkspaceDataStore

    public commonResearchTypes = [
        'physicalContainerItem',
        'numericContainerItem',
        'physicalAccessoryItem',
        'numericAccessoryItem',
    ]

    public specificResearchTypes = {
        movies: [
            'physicalFilmItem',
            'NumericFilmItem'
        ],
        museum: [
            'physicalMuseumItem',
            'numericMuseumItem'
        ]
    }

    public researchTypes: string[] = []

    public created() {
        this.$itemDatastore = ItemDataStore.getInstance()
    }

    public mounted() {
        this.researchTypes = this.commonResearchTypes.concat(this.specificResearchTypes[this.$workspaceDataStore.currentWorkspaceInfo.type])
    }

    public openItemModal() {
        ;(this.$refs.selectItemMapModal as SelectItemMultipleModal).open()
    }

    public onItemSelected({ id: itemId }: { id: string }) {
        this.$itemDatastore.fetchOne(itemId).subscribe((item) => {
            this.selectedItem = item
            ;(this.$refs.chooseItemModal as LocationSelectorPopup).open()
            ;(this.$refs.selectItemMapModal as SelectItemMultipleModal).close()
        })
    }

    public onLocationValidated(location: {
        location: { id: string }
        setPermanentLocation: boolean
    }) {
        if (this.selectedItem) {
            _.set(
                this.selectedItem,
                'locationItemSchema.realTimeLocation.realTimeLocation',
                location.location.id,
            )
            _.set(
                this.selectedItem,
                'locationItemSchema.realTimeLocation.effectiveDate.startInterval.date',
                Date.now(),
            )
            _.set(
                this.selectedItem,
                'locationItemSchema.realTimeLocation.effectiveDate.useDate',
                'DATE'
            )
            if (location.setPermanentLocation) {
                _.set(
                    this.selectedItem,
                    'locationItemSchema.permanentLocation.permanentLocation',
                    location.location.id,
                )
                _.set(
                    this.selectedItem,
                    'locationItemSchema.permanentLocation.effectiveDate.startInterval.date',
                    Date.now(),
                )
                _.set(
                    this.selectedItem,
                    'locationItemSchema.permanentLocation.effectiveDate.useDate',
                    'DATE'
                )
            }
            this.$itemDatastore.update(this.selectedItem.id, this.selectedItem).subscribe(
                () =>
                    this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                        message: this.$t('entity.mapModal.saveNotification.locationChanged'),
                        variant: 'success',
                    }),
                () =>
                    this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                        message: this.$t('entity.mapModal.saveNotification.errorMessage'),
                        variant: 'success',
                    }),
            )
        }
    }

    public onContainerValidated({ container } : { container: Container }) {
        if (this.selectedItem) {
            if (
                _.defaultTo(this.selectedItem?.conditioningItemSchema?.actualContainer, [])
                .find(actualContainer => actualContainer.container === container.id)
            ) {
                this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                    message: this.$t('entity.mapModal.saveNotification.itemAlreadyInContainer'),
                    variant: 'danger'
                })
            } else {
                _.set(
                    this.selectedItem,
                    'conditioningItemSchema.actualContainer',
                    _.defaultTo(this.selectedItem?.conditioningItemSchema?.actualContainer, []).concat([
                        {
                            container: container.id,
                            date: getCurrentDateAsSkinDate(),
                        },
                    ]),
                )
                this.$itemDatastore.update(this.selectedItem.id, this.selectedItem).subscribe(
                    () =>
                        this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                            message: this.$t('entity.mapModal.saveNotification.containerChanged'),
                            variant: 'success',
                        }),
                    () =>
                        this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                            message: this.$t('entity.mapModal.saveNotification.errorMessage'),
                            variant: 'danger',
                        }),
                )
            }
        }
    }
}
